module.exports = __webpack_public_path__ + "static/img/login_logo.b3d7f50.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/configure/ssipc/login_logo.png
// module id = dzKs
// module chunks = 23